// Conjugator language options — shared by the Preferences picker (and anywhere
// else that needs the flag + label for a language value stored in useSetLanguage).
export const languageOptions = [
  { value: "französisch", label: "🇫🇷 Französisch" },
  { value: "englisch", label: "🇬🇧 Englisch" },
  { value: "spanisch", label: "🇪🇸 Spanisch" },
  { value: "deutsch", label: "🇩🇪 Deutsch" },
  { value: "italienisch", label: "🇮🇹 Italienisch" },
  { value: "hebräisch", label: "🇮🇱 Hebräisch" },
  { value: "portugiesisch", label: "🇵🇹 Portugiesisch" },
  { value: "arabisch", label: "🇸🇦 Arabisch" },
  { value: "japanisch", label: "🇯🇵 Japanisch" },
];
